import { Card, type CardProps } from '@mantine/core'
import { clsx } from 'clsx'
import React from 'react'

import { Extra } from './Extra'
import { Icon } from './Icon'
import styles from './styles.module.css'
import { Title } from './Title'
import { Value } from './Value'

type CardMetricProps = CardProps

export function CardMetric({ className, children, ...props }: CardMetricProps) {
  const classes = clsx(styles.cardMetric, className)

  return (
    <Card style={{ flex: 1 }} {...props} className={classes} withBorder>
      {children}
    </Card>
  )
}

CardMetric.Icon = Icon
CardMetric.Extra = Extra
CardMetric.Title = Title
CardMetric.Value = Value
